<template>
    <div class="bcw bcw__last_reports" :class="{'zero__reports': days.length === 0}">
        <header>
            <div>
                <p class="title">{{ trans('dashboard.last.title1') }} <span>{{ trans('dashboard.last.title2') }}</span></p>
                <p class="subtitle" v-if="days.length">
                    {{ trans('dashboard.last.sub') }} {{ formatDate(days[0].finish_day) }}{{ formatYear(days[0].finish_day) }}
                </p>
            </div>

        </header>
        <main class="">
        <div class="list__heading">
            <p>{{ trans('dashboard.last.table.crop') }}</p>
            <p>{{ trans('dashboard.last.table.name') }}</p>
            <p>{{ trans('dashboard.last.table.num') }}</p>
            <p>{{ trans('dashboard.last.table.actions') }}</p>
            <p>{{ trans('dashboard.last.table.date') }}</p>
        </div>
        <ol :class="{'align--end': this.days.length > 5}" class="scrollbar--vertical scrollbar--horizontal">
            <li v-for="(day, i) of days" :key="i">
                <img :src="day.logoImg">
                <div>
                    <p class="name">
                        <span>{{ trans('common::crop.' + day.crop_name) }} </span>
                        <span class="sub" v-if="day.subclient">
                                - {{ day.subclient.name }} ({{ day.subclient.code }})
                        </span>
                    </p>

                    <span v-if="day.samples.length < 5">
                        {{ day.samples.map(s => s.code).join(', ') }}
                    </span>
                    <span v-else>
                        {{ day.samples.map(s => s.code).slice(0, 3).join(', ') }}
                        ...
                        {{day.samples[day.samples.length - 1].code}}
                    </span>

                </div>
                <VTooltip :triggers="['hover']" placement='top' :distance=5 theme='reports'>
                    <!-- Popover target -->
                    <p class="num">x{{day.samples.length}}</p>
                    <!-- Content of popover -->
                    <template #popper>
                        <p class="title">{{ trans('dashboard.last.codes') }}</p>
                        <ul>
                            <li v-for="(sam, j) in day.samples.slice(0, 25)" :key="j">
                                <p><span class="bg--nut"></span> {{ sam.code }}</p>
                            </li>
                            <li v-if="day.samples.length > 25">
                                {{ trans('dashboard.last.and') }} {{day.samples.length - 25}}
                            </li>
                        </ul>
                    </template>
                </VTooltip>
                <div class="actions">
                  <form :id="'formEye_'+i"  action="/reports" method="post">
                    <input type="hidden" name="_token" :value="day.token">
                    <input type="hidden" name="samples" :value="day.getCodesInURL()">
                    <input type="hidden" name="client_id" :value="day.client_id">
                    <input type="hidden" name="crop_id" :value="day.crop_id">
                    <input type="hidden" name="search" value="last_reports">
                    <a :title="trans('dashboard.last.see_all')"  @click.prevent="day.submit(i)">
                        <eye size="1"></eye>
                    </a>
                  </form>
                  <a v-if="!day.downloadInfo.downloading" href="#" target="_blank"
                       :title="trans('dashboard.last.download_pdf')"
                       @click.prevent="day.download()"
                    >
                        <arrow-down :size="16"></arrow-down>
                    </a>
                    <div v-else class="donut__progress__cont" :class="'donut--'+day.logo_name">
                        <donut-progress :val="day.downloadInfo.donutCurrent" :max="day.downloadInfo.donutMax" />
                        <loader :dim="14"></loader>
                        <p>{{day.downloadInfo.donutCurrent}}/<span>{{day.downloadInfo.donutMax}}</span></p>
                    </div>
                </div>
                <time :datetime="day.finish_day" class="date">
                    {{ formatDate(day.finish_day) }}<span>{{ formatYear(day.finish_day) }}</span>
                </time>
            </li>
        </ol>
        </main>
        <div class="zero__reports__content">
            <div class="zero__inner">
                <div class="img__cont">
                    <img src="/images/reportscol.svg">
                    <div>
                        <p class="title">{{ trans('dashboard.last.zero.title') }}</p>
                        <p class="subtitle">{{ trans('dashboard.last.zero.sub') }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped >

</style>

<script>

import {ArrowDown, Eye} from 'lucide-vue-next';
import moment from 'moment';
import Zip from '../../../../../../common/assets/js/utils/zip';

class Day {
  token = document.querySelector('meta[name="csrf-token"]').content
    constructor(rawday, subclients = null) {
        this.client_id = rawday.client_id;
        this.crop_id = rawday.crop_id;
        this.crop_name = rawday.crop_name;
        this.logo_name = rawday.logo_name;
        this.finish_day = rawday.finish_day;
        this.samples = rawday.samples;

        this.downloadInfo = {
            downloading: false,
            donutMax: 1,
            donutCurrent: 0,
        };

        const redirect = '/reports?list=' + this.getCodesInURL();

        if (subclients) {
            this.url = `/subclient/switch/${this.client_id}/${this.crop_id}?redirect=${redirect}`;
            this.subclient = subclients.filter(sub => sub.id === this.client_id)[0];
        } else {
            this.url = `/crop/switch/${this.crop_id}?redirect=${redirect}`;
            this.subclient = null;
        }
    }

    get logoImg() {
        return '/crop/pic/color/' + this.logo_name;
    }

  getCodesInURL(day) {
        let codeString = '';
        this.samples.forEach((sample) => {
            codeString = codeString + sample.code + ',';
        });
        codeString = codeString.slice(0, -1);
        return codeString;
    }

  submit(i) {
      const form = window.document.getElementById('formEye_' + i)
      form.submit()
  }

    async download(day) {
        this.downloadInfo.downloading = true;
        this.downloadInfo.donutMax = this.samples.length;
        const zipname = 'Samples_' + this.finish_day + '.zip';

        const zip = new Zip();

        for (const [i, sample] of this.samples.entries()) {
            this.downloadInfo.donutCurrent = i + 1;
            const url = '/report/pdf/' + sample.code;
            await zip.addURL(url);
        }

        await zip.download(zipname);

        this.downloadInfo.downloading = false;

        window.mixpanel.track('Bulk Report Download');
    }

}

export default {
    props: [
        'widget',
        'subclients',
    ],

    components: {
        ArrowDown, Eye
    },

    data() {
        return {
            days: this.widget.data().map(rawday => new Day(rawday, this.subclients)),
        };
    },
    methods: {
        formatDate(mydate) {
            return moment(mydate).format('DDMMM').replace('.', '').toString();
        },
        formatYear(mydate) {
            return moment(mydate).format('YYYY').replace('.', '').toString();
        }
    }

};

</script>
